<template>
  <div class="wrapper">
    <!--视频-->
    <video-player id="video2" class="video-player vjs-custom-skin" ref="videoPlayer2" :playsinline="playsinline"
      :options="playerOptions2" @canplay="onPlayerCanplay2($event)"></video-player>
    <div class="detail-top">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" key="0" v-if="goods_detail.commodityVideo">
            <!--视频-->
            <video-player v-if="playerShow" id="video" class="video-player vjs-custom-skin" ref="videoPlayer"
              :playsinline="playsinline" :options="playerOptions"></video-player>
            <div v-else>
              <img class="img" :src="(goods_detail.commodityVideoCover || images[0]) +
                `${imgCrop}resize,w_700`
                " />
              <div class="player" @click="loadVideo">
                <img src="../../assets/images/purchaseCommdity/play.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="swiper-slide" @click="showImageArr(images, index)" v-for="(image, index) in images"
            :key="index + 1">
            <img class="img" :src="image + `${imgCrop}resize,w_700`" />
          </div>
        </div>
        <div :style="{ top: playing ? '6.22rem' : '6.94rem' }" class="custom-indicator" slot="indicator">
          {{ current + 1 }}/{{
            goods_detail.commodityVideo ? images.length + 1 : images.length
          }}
        </div>
      </div>
    </div>
    <div class="detail-price">
      <div class="detail-priceC">
        <div class="detail-price1" v-if="roleText == 'Sell' && goods_detail.showPrice">
          <i>￥</i>{{ `${goods_detail.showPrice}` }}
        </div>
        <!-- <div class="detail-price1" v-else-if=" goods_detail[`min${roleText}Price`] != goods_detail[`max${roleText}Price`]">
          <i>￥</i>{{`${goods_detail[`min${roleText}Price`]}-${goods_detail[`max${roleText}Price`]}`}}
        </div> -->
        <div class="detail-price1" v-else>
          <i>￥</i>{{ goods_detail[`min${roleText}Price`] }}
        </div>
        <div class="detail-sale">
          <span>原价:{{ goods_detail.commodityInventoryList[0].oldPrice }}</span>
          <div class="detail-price2">秒杀价</div>
        </div>
      </div>
      <div class="detail-downlr"
        v-if="countdowns == '00:00:00' && dataLoading && goods_detail.endTime != '2030-01-01 00:00:00'">
        <div class="detailtiem" v-if="countdown != '00:00:00:00'">
          <span>距结束仅剩</span>
          <div class="detail-times">
            <span v-if="countdown.split(':')[0] != '00'">{{
              countdown.split(":")[0]
            }}</span>
            <i v-if="countdown.split(':')[0] != '00'">天</i>
            <span>{{ countdown.split(":")[1] }}</span>
            <i>:</i>
            <span>{{ countdown.split(":")[2] }}</span>
            <i>:</i>
            <span>{{ countdown.split(":")[3] }}</span>
          </div>
        </div>
        <span class="detailtext" v-else>秒杀已结束</span>
      </div>
      <div class="sales-right" v-if="countdowns != '00:00:00' && dataLoading">
        <span class="timetext">距开始仅剩</span>
        <div class="sales-right-time" v-if="this.countdowns != '00:00:00'">
          <span>{{ this.countdowns.split(":")[0] }}</span>
          <i>:</i>
          <span>{{ this.countdowns.split(":")[1] }}</span>
          <i>:</i>
          <span>{{ this.countdowns.split(":")[2] }}</span>
        </div>
        <span v-if="countdowns == '00:00:00'">{{ countdowns }}</span>
      </div>
      <img v-if="countdowns == '00:00:00' && dataLoading && goods_detail.endTime != '2030-01-01 00:00:00'"
        class="countdownBg" src="../../assets/images/listdetail/countdownBg1.png" alt />
      <img v-if="countdowns != '00:00:00' && dataLoading" class="countdownBg"
        src="../../assets/images/listdetail/countdownBg2.png" alt />
    </div>
    <div class="nameBox">
      <div class="detail-name">
        <div class="detail-name-left">
          <p class="commodityName">{{ goods_detail.commodityName }}</p>
          <!-- <p class="commoditySummary">{{goods_detail.commoditySummary}}</p> -->
        </div>
        <div class="detail-name-right" @click="toStoreList" v-if="storeInfo.nbr">
          <img src="../../assets/images/listdetail/store.png" alt />
          <span>店铺信息</span>
        </div>
      </div>
      <div class="rowBox">
        <div class="rowBoxLeft">
          <div class="detail-item">
            <div class="detail-coupon style1" v-show="goods_detail.isUseCoupon == '1'">可使用优惠券</div>
            <div class="detail-coupon1 style1" v-show="coupon_name">赠送优惠券</div>
          </div>
          <img src="../../assets/images/listdetail/buyTip.png" alt />
        </div>
        <div class="rowBoxRight">
          <div class="detail-collection" @click="collected">
            <img src="../../assets/images/listdetail/AddingCollections.png" alt v-if="isCollected == 0" />
            <img src="../../assets/images/listdetail/Successfulcollection.png" alt v-else />
            <span>收藏</span>
          </div>
          <div class="detail-iocn" @click="goqrcode">
            <img src="../../assets/images/listdetail/share3.png" alt />
            <span>种草</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品优惠券 -->
    <div class="couponList" v-if="couponList.length > 0">
      <div :class="{ volume: true, active: Number(item.user_get_num) >= Number(item.get_limit_num) }"
        v-for="(item, index) in couponList" :key="index">
        <div class="left">
          <span class="one">
            <span>￥</span>
            <div class="amount">
              {{ parseFloat(parseFloat(item.total_amount).toFixed(2)) }}
            </div>
          </span>
          <span class="two" v-if="item.limit_condition > 0">满{{
            parseFloat(parseFloat(item.limit_condition).toFixed(2))
          }}元可使用</span>
          <span class="two" v-if="item.limit_condition == 0">无门槛券</span>
        </div>
        <div class="right">
          <div class="lefttext">
            <span class="name">{{ item.name }}</span>
            <span class="time">{{
              item.end_time ? item.end_time : item.duration + "天"
            }}到期</span>
            <span class="time">每个用户限领{{ item.get_limit_num }}次</span>
          </div>
          <div class="rightimg">
            <img v-if="Number(item.user_get_num) < Number(item.get_limit_num)"
              src="../../assets/images/securities/three.png" alt />
            <span v-if="Number(item.user_get_num) < Number(item.get_limit_num)" class="receive"
              @click.stop="showNotice(item, index)">立即领取</span>
            <img v-if="Number(item.user_get_num) >= Number(item.get_limit_num)"
              src="../../assets/images/securities/two.png" alt />
            <span v-if="Number(item.user_get_num) >= Number(item.get_limit_num)" class="receives">已领取</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tabBox">
      <div :class="{ tabItem: true, active: activeTab == '0' }" @click.stop="changeTab('0')">
        <span>商品详情</span>
      </div>
      <div :class="{ tabItem: true, active: activeTab == '1' }" @click.stop="changeTab('1')">
        <span>发圈素材</span>
      </div>
      <div :class="{ tabItem: true, active: activeTab == '2' }" @click.stop="changeTab('2')">
        <span>关于售后</span>
      </div>
      <div v-if="goods_detail.licensePic" :class="{ tabItem: true, active: activeTab == '3' }" @click.stop="changeTab('3')">
        <span>经营资质</span>
      </div>
    </div>
    <!-- 商品详情 -->
    <div v-if="activeTab == '0'">
      <div class="lineTitle">
        <div class="line"></div>
        <span>商品详情</span>
        <div class="line"></div>
      </div>
      <!-- 视频展示 -->
      <div v-if="videoList.length > 0 && !this.goods_detail.noteId" class="descVideoWrap">
        <!-- <div class="detail-list-t" style="width: 100%;box-sizing: border-box;margin-left: 0;padding-left: .24rem;">视频展示
          </div> -->
        <div class="descVideoBox" v-for="(video, index) in videoList" :key="index">
          <video-player v-if="video.loadVideo" id="video3" class="video-player vjs-custom-skin" ref="descVideoPlayer"
            :playsinline="playsinline" :options="descPlayerOptions"></video-player>
          <div v-else class="descVideoImg">
            <img class="img" :src="(video.cover) +
              `${imgCrop}resize,w_700`
              " />
            <div class="player" @click="loadDescVideo(index)">
              <img src="../../assets/images/purchaseCommdity/play.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.goods_detail.noteId" class="siyuBox">
        <div class="siyuBoxItem" v-for="(siyuItem, index) in siyuInfo" :key="index + 1">
          <p v-if="siyuItem.type == '1'">{{ siyuItem.content }}</p>
          <img class="siyuImg" v-if="siyuItem.type == '2'" :src="siyuItem.content"
            @click="showSiyuImage(siyuItem.content)" />
          <video-player v-if="siyuItem.type == '3'" class="video-player vjs-custom-skin siyuVideo"
            :playsinline="playsinline" :options="siyuItem.options"></video-player>
        </div>
      </div>

      <!-- 图文详情 -->
      <div v-else class="detailHtml" id="detaillist">
        <!-- <div class="detail-list-t">图文详情</div> -->
        <div class="detail-list-m" v-html="goods_detail.commodityDesc"></div>
      </div>
    </div>
    <!-- 素材 -->
    <div v-if="activeTab == '1'">
      <div class="lineTitle">
        <div class="line"></div>
        <span v-if="materialTotal == 0">暂无信息</span>
        <span v-else>发圈素材</span>
        <div class="line"></div>
      </div>
      <div class="evaluate" id="material">
        <div class="evaluate-box" v-if="materialTotal == 0">
          <span class="evaluate-span">暂无素材</span>
          <!-- <span class="evaluate-span" >暂无评价</span> -->
          <div class="evaluate-text">
            <img src="../../assets/images/listdetail/back.svg" alt />
          </div>
        </div>
        <div class="mainDetail" v-for="(item, index) in materialList" :key="index + 1">
          <div @click="toDetail(item.share_nbr)" class="content">
            {{ item.mainContent }}
          </div>

          <div class="detailWrap">
            <div class="detail" @click="toDetail(item.share_nbr)">
              查看详情<img src="../../assets/images/material/back.svg" alt="" />
            </div>
          </div>


          <div class="imgArr">
            <div class="imgContainer1" v-if="
              (item.comment_video && item.imgArr.length == 0) ||
              (!item.comment_video && item.imgArr.length == 1)
            ">
              <div v-if="item.comment_video" class="img" @click="playVideo(item.comment_video, index)">
                <img :src="item.comment_video_cover + `${imgCrop}resize,w_400`
                  " alt="" />
                <div v-if="playIndex == index" class="loading">
                  <van-loading class="loadingIcon" type="spinner" color="#fff" />
                </div>
                <div v-else class="player">
                  <img class="playIcon" src="../../assets/images/purchaseCommdity/play.svg" alt="" />
                </div>
              </div>
              <div class="img" @click="showImageArr(item.imgArr, index1)" v-for="(img, index1) in item.imgArr"
                :key="index1 + 1">
                <img :src="img + `${imgCrop}resize,w_400`" alt="" />
              </div>
            </div>
            <div class="imgContainer2" v-else-if="
              (item.comment_video && item.imgArr.length == 1) ||
              (!item.comment_video && item.imgArr.length == 2)
            ">
              <div v-if="item.comment_video" class="img" @click="playVideo(item.comment_video, index)">
                <img :src="item.comment_video_cover + `${imgCrop}resize,w_400`
                  " alt="" />
                <div v-if="playIndex == index" class="loading">
                  <van-loading class="loadingIcon" type="spinner" color="#fff" />
                </div>
                <div v-else class="player">
                  <img class="playIcon" src="../../assets/images/purchaseCommdity/play.svg" alt="" />
                </div>
              </div>
              <div class="img" @click="showImageArr(item.imgArr, index2)" v-for="(img, index2) in item.imgArr"
                :key="index2 + 1">
                <img :src="img + `${imgCrop}resize,w_300`" alt="" />
              </div>
            </div>
            <div class="imgContainer4" v-else-if="
              (item.comment_video && item.imgArr.length == 3) ||
              (!item.comment_video && item.imgArr.length == 4)
            ">
              <div v-if="item.comment_video" class="img" @click="playVideo(item.comment_video, index)">
                <img :src="item.comment_video_cover + `${imgCrop}resize,w_400`
                  " alt="" />
                <div v-if="playIndex == index" class="loading">
                  <van-loading class="loadingIcon" type="spinner" color="#fff" />
                </div>
                <div v-else class="player">
                  <img class="playIcon" src="../../assets/images/purchaseCommdity/play.svg" alt="" />
                </div>
              </div>
              <div @click="showImageArr(item.imgArr, index3)" v-for="(img, index3) in item.imgArr" :key="index3 + 1"
                class="img">
                <img :src="img + `${imgCrop}resize,w_300`" alt="" />
              </div>
            </div>
            <div class="imgContainerOther" v-else>
              <div v-if="item.comment_video" class="img" @click="playVideo(item.comment_video, index)">
                <img :src="item.comment_video_cover + `${imgCrop}resize,w_400`
                  " alt="" />
                <div v-if="playIndex == index" class="loading">
                  <van-loading class="loadingIcon" type="spinner" color="#fff" />
                </div>
                <div v-else class="player">
                  <img class="playIcon" src="../../assets/images/purchaseCommdity/play.svg" alt="" />
                </div>
              </div>
              <div class="img" @click="showImageArr(item.imgArr, index4)" v-for="(img, index4) in item.imgArr.slice(
                0,
                item.comment_video ? 8 : 9
              )" :key="index4 + 1">
                <img :src="img + `${imgCrop}resize,w_250`" alt="" />
              </div>
              <template
                v-if="(item.comment_video ? 1 + item.imgArr.slice(0, 8).length : item.imgArr.slice(0, 9).length) % 3 != 0">
                <div
                  v-for="(img, index5) in new Array(3 - ((item.imgArr.length + (item.comment_video ? 1 : 0)) % 3)).join(',').split(',')"
                  class="img visibility" :key="index5">
                  <img src="" alt="" />
                </div>
              </template>
            </div>
          </div>

          <div class="share">
            <div class="left">
              <img v-show="item.mainName" :src="item.share_head_pic" alt="" />
              <div v-show="item.mainName">{{ item.mainName }}刚刚分享</div>
            </div>
            <div class="right">
              <div class="saveBtn" @click="copy" data-clipboard-action="copy" :data-clipboard-text="item.content">
                <div>复制文案</div>
              </div>
              <div @click="goqrcode1(index)" class="shareBtn">
                <div>
                  <img src="../../assets/images/material/share.svg" alt="" />分享
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 售后 -->
    <div v-if="activeTab == '2'">
      <div class="lineTitle">
        <div class="line"></div>
        <span>关于售后</span>
        <div class="line"></div>
      </div>
      <img style="width: 100%;" :src="cdnImgPath + '/images/static/afterSales.jpg'" alt />
    </div>

    <!-- 经营执照 -->
    <div v-if="activeTab == '3'">
      <div class="lineTitle">
        <div class="line"></div>
        <span>经营资质</span>
        <div class="line"></div>
      </div>
      <div class="licenseBox">
        <img class="imgs" :src="img" alt="" v-for="(img, index) in licensePicArr" :key="index"
          @click="showImageArr(licensePicArr, index)">
      </div>
    </div>

    <!-- 评价 -->
    <div class="evaluate" id="evaluate" style="display: none">
      <div class="evaluate-box">
        <span class="evaluate-span" v-if="evaluate.length > 0">商品评价({{ totalRows }}条)</span>
        <span class="evaluate-span" v-else>暂无评价</span>
        <div class="evaluate-text" @click="goFeedBack(evaluate.length)">
          <span class="text-span" v-if="evaluate.length > 0">好评<i>{{ goods_detail.evaluateAvg }}%</i></span>
          <img src="../../assets/images/listdetail/back.svg" alt />
        </div>
      </div>
      <div class="evaluate-content">
        <div class="evaluate-content-box" v-for="(item, index) in evaluate" :key="index">
          <div class="evaluate-content-user">
            <img :src="item.head_pic" alt />
            <span>{{ item.nick_name }}</span>
          </div>
          <div class="evaluate-content-text" v-if="item.content">
            <span>{{ item.content }}</span>
          </div>
          <div class="evaluate-content-img" v-if="item.images || item.comment_video">
            <div v-if="item.comment_video" @click="
              playVideo(item.comment_video, index + materialList.length)
              " class="evaluate-content-boxs">
              <img :src="item.comment_video_cover + `${imgCrop}resize,w_200`
                " alt />
              <div v-if="playIndex == index + materialList.length" class="loading">
                <van-loading class="loadingIcon" type="spinner" color="#fff" />
              </div>
              <div v-else class="player">
                <img class="playIcon" src="../../assets/images/purchaseCommdity/play.svg" alt="" />
              </div>
            </div>
            <div class="evaluate-content-boxs" v-for="(img, index1) in item.images"
              @click="showImageArr(item.images, index1)" :key="index1">
              <img :src="img + `${imgCrop}resize,w_200`" alt />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-dibu">
      <div class="detail-dibu-box">
        <div class="detail-dibu1" @click="toIndexCheck">
          <div class="detail-dibu1t">
            <img src="../../assets/images/purchaseCommdity/home.svg" alt />
            <span class="detail-dibu1b">首页</span>
          </div>
        </div>

        <div class="detail-dibu3" @click="tocart">
          <div class="detail-dibu1t">
            <img src="../../assets/images/listdetail/shoppingcar.svg" alt />
            <div class="detail-dibu1b">购物车</div>
          </div>
        </div>
        <div class="flex-box">
          <div class="flextop">
            <div
              v-if="(goods_detail.endTime != `2030-01-01 00:00:00` && countdown == '00:00:00:00') || goods_detail.state == 2 || goods_detail.state == 3"
              class="detail-dibu-no">
              <span>已下架</span>
            </div>

            <div class="detail-dibu-no" v-else-if="goods_detail.state == 1 && goods_detail.totalQuantity == 0">
              <span>该商品已售罄</span>
            </div>

            <div @click="warn == 0 ? remind() : ''" v-else-if="
              countdowns != '00:00:00' &&
              goods_detail.state == 1 &&
              goods_detail.totalQuantity > 0
            " :class="this.warn == 0 ? 'detail-dibu-active' : 'detail-dibu-no'">
              <span v-if="this.warn == 0">设置提醒</span>
              <span v-else>已设置</span>
            </div>
            <div v-if="
              !(goods_detail.endTime != `2030-01-01 00:00:00` && countdown == '00:00:00:00') &&
              countdowns == '00:00:00' &&
              goods_detail.state == 1 &&
              goods_detail.totalQuantity > 0 &&
              roleText != 'Sell' &&
              false
            " class="detail-dibu5" @click="upguige">
              <span>购买</span>
              <span v-if="
                goods_detail[`minSellPrice`] -
                goods_detail[`min${roleText}Price`] !=
                0
              ">已省{{
                  parseInt(
                    Math.round(
                      (goods_detail[`minSellPrice`] -
                        goods_detail[`min${roleText}Price`]) *
                      100
                    ) / 100
                  ) ==
                    Math.round(
                      (goods_detail[`minSellPrice`] -
                        goods_detail[`min${roleText}Price`]) *
                      100
                    ) /
                    100
                    ? Math.round(
                      (goods_detail[`minSellPrice`] -
                        goods_detail[`min${roleText}Price`]) *
                      100
                    ) /
                    100 +
                    ".00"
                    : Math.round(
                      (goods_detail[`minSellPrice`] -
                        goods_detail[`min${roleText}Price`]) *
                      100
                    ) / 100
                }}</span>
              <!-- <span>已省{{Math.round((assessmentDetail[`sellPrice`] - assessmentDetail[`${roleText.toLowerCase()}Price`])*100)/100}}</span> -->
            </div>
            <div class="detail-dibu4" @click="goqrcode" v-if="
              !(goods_detail.endTime != `2030-01-01 00:00:00` && countdown == '00:00:00:00') &&
              countdowns == '00:00:00' &&
              goods_detail.state == 1 &&
              goods_detail.totalQuantity > 0 &&
              roleText != 'Sell'&&
              false
            ">
              <span>推荐好物</span>
            </div>

            <div class="flexbottom"
              v-if="roleText != 'Sell1' && goods_detail.totalQuantity > 0 && !(goods_detail.endTime != `2030-01-01 00:00:00` && countdown == '00:00:00:00') && countdowns == '00:00:00' && goods_detail.state == 1">
              <div v-if="goods_detail.isPickupStore != '1'" class="detail-dibu5" @click="showup">
                <span>加入购物车</span>
              </div>
              <div :class="{ 'detail-dibu4': true, 'detail-btn-border': goods_detail.isPickupStore == '1' }" @click="upguige">
                <span>立即购买</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
      <img src="../../assets/images/listdetail/detialToTop.png" />
    </div>

    <!-- 底部 -->
    <div class="guige-popup" v-show="show">
      <van-popup v-model="show" position="bottom" :overlay="true">
        <!--<div class="guige-popupbox">-->
        <div class="guige-popupt">
          <div class="guige-popuptl">
            <div class="guige-popuptll">
              <img @click="showImage(assessmentDetail.inventoryLogo)" v-if="assessmentDetail.inventoryLogo" :src="assessmentDetail.inventoryLogo +
                `${imgCrop}resize,w_300`
                " alt />
              <img @click="showImage(goods_detail.commodityLogo)" v-else :src="goods_detail.commodityLogo +
                `${imgCrop}resize,w_300`
                " alt />
            </div>
            <div class="guige-popuptlr">
              <p v-if="assessmentDetail[`${roleText.toLocaleLowerCase()}Price`]">
                ￥{{ assessmentDetail[`${roleText.toLocaleLowerCase()}Price`] }}
              </p>
              <p v-else>￥{{ goods_detail[`min${roleText}Price`] }}</p>
              <p v-if="
                goods_detail.isQuantityShow == 1 && assessmentDetail.quantity
              ">
                库存：{{ assessmentDetail.quantity }}
              </p>
              <p v-else-if="goods_detail.isQuantityShow == 1">
                库存：{{ quantity }}
              </p>
              <p v-else></p>
              <p v-show="guigeCount == selectArr.length"><span>请选择</span></p>
              <p v-show="guigeCount != selectArr.length">
                <span>已选：</span><span class="grey">{{ guige }}</span>
              </p>
            </div>
          </div>
          <div class="guige-popuptr" @click="closeshowup">
            <img src="../../assets/images/icon_close.svg" alt />
          </div>
        </div>
        <div class="guige-popupc-wrap">
          <div class="guige-popupc" v-for="(item, n) in propertyListJson" :key="n">
            <div class="guige-popupct">{{ item.name }}</div>
            <div class="guige-popupcc">
              <div class="guige-popupccm" v-for="(items, index) in item.children" :key="index" v-on:click="
                specificationBtn(item.name, items.name, items.quantity)
                " v-bind:class="items.quantity == 0
                    ? 'nostock'
                    : [
                      JSON.stringify(selectArr).indexOf(
                        JSON.stringify({ key: item.name, value: items.name })
                      ) != -1
                        ? 'productActive'
                        : '',
                    ]
                  ">
                <span>{{ items.name }}</span>
              </div>
              <!--noneActive-->
            </div>
          </div>
        </div>
        <div class="guige-popupn">
          <div class="guige-popupnl">
            数量
            <span v-if="goods_detail.limitQuantity > 0">(每个ID限购{{ goods_detail.limitQuantity }}件)</span>
          </div>
          <div class="guige-popupnr">
            <span :style="{ color: '#999' }" v-if="quantity == 0">-</span>
            <span @click="changeNum(-(assessmentDetail.addStep || 1))" :style="{ color: lowPriceStyle ? '#999' : '' }"
              v-else>-</span>
            <input :style="{ background: '#fff' }" type="number" v-model="num" @input="checkNum" @blur="blurChange"
              v-if="quantity == 0" disabled />
            <input type="number" v-model="num" @blur="blurChange" v-else />
            <span :style="{ color: '#999' }" v-if="quantity == 0">+</span>
            <span @click="changeNum(assessmentDetail.addStep || 1)" :style="{ color: highPriceStyle ? '#999' : '' }"
              v-else>+</span>
          </div>
        </div>
        <div class="guaranteeWrap" v-if="postage_pay">
          <div class="guaranteeTitle">
            <span>保障服务</span>
          </div>
          <div class="guaranteeBox">
            <div :class="{ guaranteeItem: true, active: postageBuy }" @click.stop="postageBuy = !postageBuy">
              <span>退换无忧上门取件 | ￥{{ postage_pay }}</span>
            </div>
          </div>
        </div>
        <div class="guige-popupnb">
          <div class="guige-popupnbl" @click="gocart" v-if="
            goods_detail.isPickupStore != '1' &&
            countdowns == '00:00:00' &&
            goods_detail.state == 1 &&
            goods_detail.totalQuantity > 0
          ">
            加入购物车
          </div>
          <div class="guige-popupnbr" @click="gobuy" v-if="
            countdowns == '00:00:00' &&
            goods_detail.state == 1 &&
            goods_detail.totalQuantity > 0
          ">
            立即购买
          </div>
          <div class="guige-popupnbr-time" v-else-if="
            goods_detail.state == 1 && goods_detail.totalQuantity == 0
          ">
            <span>该商品已售馨</span>
          </div>
          <div @click="warn == 0 ? remind() : ''" :class="this.warn == 0 ? 'guige-popupnbr-time' : 'guige-popupnbr-time'
            " v-else-if="countdowns != '00:00:00' && goods_detail.state == 1">
            <span v-if="this.warn == 0">设置提醒</span>
            <span v-else>已设置</span>
          </div>
          <div class="guige-popupnbr-time" v-else>已下架</div>
        </div>
        <!--</div>-->
      </van-popup>
    </div>

    <!-- 确定花费积分吗 -->
    <van-popup v-model="noticeShow" :close-on-click-overlay="false" style="border-radius: 0.2rem">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定花费{{
          parseFloat(selectCouponItem.integral_price)
        }}积分兑换？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="noticeShow = false">取消</van-col>
          <van-col class="confirm" @click.native.stop="collar(selectCouponItem, selectIndex)">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>

    <!-- 规格弹窗 -->
    <div class="box">
      <van-popup v-model="showshare1" @click-overlay="colseshare1" class="van-popup">
        <div class="imgCotainer">
          <img :src="shareImage" alt="" class="swiper-showImg" />
        </div>
      </van-popup>
      <div class="hold" v-if="showshare1">
        <div @click="wechatShareBtn1">
          <img src="../../assets/images/Sharing_Friends.png" /><br />
          <span>分享好友</span>
        </div>
        <div @click="wechatShareBtn2">
          <img src="../../assets/images/Sharing_Friends2.png" /><br />
          <span>分享朋友圈</span>
        </div>
        <div @click="downloadImg">
          <img src="../../assets/images/Save_pictures.png" /><br />
          <a :dowanload="htmlUrl1">下载图片</a>
        </div>
      </div>
    </div>

    <div class="container" v-show="qrcodeshare">
      <van-popup v-model="showshare" @click-overlay="colseshare">
        <div class="shareBox" ref="shareBox">
          <img :src="commodityShareArr[0] || ''" alt="" class="shareImg" />
          <!-- <img :src="commodityShareArr[1] || ''" alt="" class="shareImg" /> -->
        </div>
      </van-popup>
      <div class="hold" v-if="showshare">
        <div @click="wechatShareBtn1">
          <img src="../../assets/images/Sharing_Friends.png" /><br />
          <span>分享好友</span>
        </div>
        <div @click="wechatShareBtn2">
          <img src="../../assets/images/Sharing_Friends2.png" /><br />
          <span>分享朋友圈</span>
        </div>
        <div @click="downloadImg">
          <img src="../../assets/images/Save_pictures.png" /><br />
          <a :dowanload="htmlUrl">下载图片</a>
        </div>
      </div>
    </div>
    <van-popup v-model="show1" style="border-radius: 0.2rem">
      <div class="servicebox">
        <img class="serviceimg" @click="show1 = false" src="./../../assets/images/information/Close.svg" alt />
        <div class="servicespan">
          <p class="wechat">关注微信公众号</p>
          <span>长按识别下方二维码</span>
          <span>关注有米日记公众号</span>
          <span>菜单底部直接联系客服</span>
        </div>
        <div class="codeimg">
          <img :src="cdnImgPath + '/images/default/gzh_qrcode.jpg'" alt />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
import { handleText } from "../../assets/js/tool";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";

export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      playerOptions: {//轮播视频播放
        autoplay: false,
        muted: false,
        loop: true,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "1:1",
        fluid: true,
        sources: [],
        poster: "",
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          remainingTimeDisplay: false,
          fullscreenToggle: true,
        },
      },
      playerOptions2: {//素材或评价视频全屏播放
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        sources: [],
        controlBar: {
          //timeDivider: true,
          //durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      descPlayerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "4:3", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          // {
          // type: "",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          // src: "" //url地址
          // }
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          //timeDivider: true,
          //durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true,
        },
      },
      siyuPlayerOptions: {
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "4:3",
        fluid: true,
        poster: "",
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          remainingTimeDisplay: false,
          fullscreenToggle: true,
        },
      },
      playIndex: -1,
      current: 0,
      oldCurrent: 0,
      playerShow: false,
      playing: false,
      show: false, //规格弹窗
      num: 1, //加减数量
      images: [], //轮播
      goods_detail: {
        commodityInventoryList: [{}],
      }, //商品所有信息
      countdowns: "", //距离开始倒计时
      countdown: "00:00:00:00", //秒杀结束倒计时
      propertyListJson: [], //规格属性
      assessmentDetail: {}, //选择出来的规格
      materialList: [], //素材列表
      materialTotal: 0,
      guige: "请选择", //已选规格
      selectArr: [], //存放被选中的值
      shopItemInfo: {}, //存放要和选中的值进行匹配的数据
      commodityShareArr: [],
      qrcodeshare: false, //分享显隐
      showshare: false, //是否显示分享图片
      imgUrl: "",
      goodNbr: "", // 商品id
      lowPriceStyle: true, // 加减价格样式
      highPriceStyle: false,
      roleText: "Sell", // 用户类型
      collectionNum: 0, // 总收藏
      quantity: 0, // 总库存
      salesNum: 0,
      isCollected: "0", // 收藏状态
      userAvatar: "",
      userName: "",
      shareSwitch: true,
      qrCode: "", //
      guigeCount: 0, // 规格未选择数
      quantityArr: [], // 为库存为0数组
      show1: false,
      evaluate: [],
      widthNum: 0,
      dataLoading: false,
      totalRows: 0,
      htmlUrl: [], //截图
      warn: 0,  //提醒状态
      coupon_name: "", //赠送优惠券名称

      shareSwitch1: true,
      qrCode1: "", //
      showshare1: false,
      shareImage: "",
      htmlUrl1: [], //截图
      user: {
        role: "粉丝",
        roleText: "sell",
      },
      isLogin: 0,
      is_support_presale_chat: 0,

      couponList: [],
      noticeShow: false,
      selectCouponItem: {},
      selectIndex: -1,
      storeInfo: {},
      videoList: [],
      toTopShow: false,
      postageBuy: false,
      postage_pay: '',
      activeTab: '0',

      siyuInfo: [],
      licensePicArr: [],
    };
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
    },
    quantity(newVal, oldVal) {
      let salesNum = parseInt(this.salesNum || "0");
      let quantity = parseInt(newVal || "0");
      let widthNum = 0;
      if (quantity + salesNum != 0) {
        widthNum =
          quantity != 0
            ? Math.floor((salesNum / (salesNum + quantity)) * 100)
            : 100;
      }
      this.widthNum = widthNum;
    },
  },
  computed: {
    player2() {
      return this.$refs.videoPlayer2.player;
    },
    playsinline() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false;
      } else {
        //ios端
        return true;
      }
    },
    ...mapGetters(["agentText", "directorText"]),
  },
  methods: {
    full(element) {
      //做兼容处理
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else {
        var docHtml = document.documentElement;
        var docBody = document.body;
        var videobox = document.getElementsByClassName("video-player");
        var cssText = "width:100%;height:100%;overflow:hidden;";
        docHtml.style.cssText = cssText;
        docBody.style.cssText = cssText;
        videobox.style.cssText = cssText + ";" + "margin:0px;padding:0px;";
        document.IsFullScreen = true;
      }
    },
    onPlayerCanplay2() {
      this.playIndex = -1;
      this.full(this.player2);
    },
    playVideo(url, index) {
      if (this.playIndex == index) return false;
      this.playIndex = index;
      this.playerOptions2.sources = [
        {
          type: "video/mp4",
          src: url,
        },
      ];
      setTimeout(() => {
        this.player2.play();
      }, 500);
    },
    onPlayerCanplay() {
      //解决自动全屏
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        document
          .getElementsByTagName("video")[1]
          .setAttribute("x-webkit-airplay", true);
        //document.getElementsByTagName('video')[0].setAttribute('x5-video-player-type','h5')
        document
          .getElementsByTagName("video")[1]
          .setAttribute("x5-playsinline", true);
        //document.getElementsByTagName('video')[0].setAttribute('webkit-playsinline',true)
        //document.getElementsByTagName('video')[0].setAttribute('playsinline',true)
      } else {
        //ios端
        //document.getElementsByTagName('video')[0].setAttribute('webkit-playsinline',"true")
        //document.getElementsByTagName('video')[0].setAttribute('playsinline',"true")
      }
    },
    loadVideo() {
      let that = this;
      that.playerShow = true;
      that.playing = true;
      setTimeout(() => {
        that.onPlayerCanplay();
        that.$refs.videoPlayer.player.play();
        that.$refs.videoPlayer.$refs.video.play();
      }, 200);
    },
    onDescPlayerCanplay() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        document.getElementsById("video3").setAttribute("x-webkit-airplay", true);
        document.getElementsById("video3").setAttribute("x5-playsinline", true);
      } else {
      }
    },
    loadDescVideo(index) {
      let that = this;
      let videoList = this.videoList
      videoList.forEach((item) => {
        item.loadVideo = false
      })
      videoList[index].loadVideo = true;
      this.descPlayerOptions.poster = videoList[index].cover;
      this.descPlayerOptions.sources = [{ src: videoList[index].url }]
      setTimeout(() => {
        that.onDescPlayerCanplay();
        that.$refs.descVideoPlayer[0].player.play();
        that.$refs.descVideoPlayer[0].$refs.video.play();
      }, 200);
    },
    changeTab(index) {
      this.activeTab = index
    },
    showNotice(item, index) {
      if (item.integral_price > 0) {
        this.noticeShow = true;
        this.selectCouponItem = item;
        this.selectIndex = index;
      } else {
        this.collar(item, index);
      }
    },
    collar(item, index) {
      let that = this;
      let obj = {
        user_nbr: this.userInfo.nbr,
        coupon_template_nbr: item.nbr,
        amount: 1,
      };
      this.$commonPost({
        jydm: "flow_70071",
        flow_70071: obj,
      })
        .then((response) => {
          that.couponList[index].user_get_num =
            parseInt(that.couponList[index].user_get_num) + 1;
          this.noticeShow = false;
          this.selectCouponItem = {};
          this.selectIndex = -1;
          this.$toast({
            message: "领取成功",
            duration: 2000,
          });
        })
        .catch((err) => {
          this.noticeShow = false;
          this.selectCouponItem = {};
          this.selectIndex = -1;
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    toIndexCheck() {
      if (this.isLogin == 0 || this.is_support_presale_chat != 1) {
        return this.$router.push({
          path: "/index",
          query: { supNbr: this.userInfo.nbr },
        });
      }
      this.showdow();
    },
    goComodityMaterial() {
      this.$router.push({
        path: "/comodityMaterial",
        query: { nbr: this.goodNbr, supNbr: this.userInfo.nbr },
      });
    },
    remind() {
      this.$commonPost({
        jydm: "flow_70122",
        flow_70122: {
          user_nbr: this.userInfo.nbr,
          commodity_nbr: this.goodNbr,
        },
      })
        .then((response) => {
          this.$toast({
            message: "开抢前五分钟提醒你哦",
            duration: 2000,
          });
          this.$commonPost({
            jydm: "flow_10057",
            flow_10057: {
              user_nbr: this.userInfo.nbr,
              commodity_nbr: this.goodNbr,
            },
          })
            .then((response) => {
              this.warn = response.warn;
            })
            .catch((err) => {
              this.$toast({
                message: err.message,
                duration: 2000,
              });
            });
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    goFeedBack(num) {
      if (num) {
        this.$router.push({
          path: "/feedback",
          query: { nbr: this.goodNbr, supNbr: this.userInfo.nbr },
        });
      }
    },
    toDetail(nbr) {
      this.$router.push({
        path: "/materialDetail",
        query: { nbr: nbr, supNbr: this.userInfo.nbr },
      });
    },
    showImageArr(img, index) {
      wx.previewImage({
        current: img[index],
        urls: img,
      });
    },
    showImage(img) {
      wx.previewImage({
        current: img,
        urls: [img],
      });
    },
    showSiyuImage(img) {
      let siyuInfo = this.siyuInfo
      let imgs = []
      siyuInfo.forEach((item) => {
        if (item.type == '2') imgs.push(item.content)
      })
      wx.previewImage({
        current: img,
        urls: imgs,
      });
    },
    toTopAnimate() {
      window.scrollTo(0, 0);
    },
    copy() {
      let cbtn = new this.$clipboard(".saveBtn");
      cbtn.on("success", (e) => {
        this.$toast({
          message: "文案已复制到剪切板中，请直接粘贴使用。",
          duration: 2000,
        });
      });
      cbtn.on("error", (e) => {
        this.$toast({
          message: "复制失败",
          duration: 2000,
        });
      });
    },
    showdow() {
      let commdity = this.goods_detail;
      this.show1 = true;
    },
    blurChange() {
      this.checkNum();
      window.scrollTo(0, 0);
    },
    toStoreList() {
      this.$router.push({
        path: "/storeList",
        query: { commodityNbr: this.goodNbr, nbr: this.storeInfo.nbr, name: encodeURIComponent(this.storeInfo.supplier_name), supNbr: this.userInfo.nbr },
      });
    },
    gocomment(id) {
      var id = id;
      this.$router.push({
        path: "/comment",
        query: { id: id, supNbr: this.userInfo.nbr },
      });
    },
    showup() {
      this.playerShow = false;
      this.playing = false;
      this.show = true;
    },
    closeshowup() {
      this.show = false;
    },
    changeNum(value) {
      let num = this.num + value;
      if (/^\d+$/g.test(num)) {
        this.num = num;
        this.checkNum();
      }
    },
    checkNum() {
      let value = this.num;
      let assessmentDetail = this.assessmentDetail;
      let limitQuantity = this.goods_detail.limitQuantity;
      this.highPriceStyle = false;
      this.lowPriceStyle = false;
      if (JSON.stringify(assessmentDetail) == "{}") {
        assessmentDetail = {
          minimumSellNum: 1,
          addStep: 1,
          quantity: this.goods_detail.totalQuantity,
        };
      }
      if (!value || value == "" || value <= assessmentDetail.minimumSellNum) {
        value = assessmentDetail.minimumSellNum;
        this.lowPriceStyle = true;
      }
      if (limitQuantity > 0) {
        if (value >= limitQuantity) {
          let low =
            (limitQuantity - assessmentDetail.minimumSellNum) %
            assessmentDetail.addStep;
          value = limitQuantity - low;
          this.highPriceStyle = true;
        } else {
          value =
            value -
            ((value - assessmentDetail.minimumSellNum) %
              assessmentDetail.addStep);
        }
      } else {
        if (value > assessmentDetail.quantity) {
          let low =
            (assessmentDetail.quantity - assessmentDetail.minimumSellNum) %
            assessmentDetail.addStep;
          value = assessmentDetail.quantity - low;
          this.highPriceStyle = true;
        } else {
          value =
            value -
            ((value - assessmentDetail.minimumSellNum) %
              assessmentDetail.addStep);
        }
      }
      this.num = parseInt(value);
    },
    gobuy() {
      let quantity = this.assessmentDetail.quantity || 0;
      if (this.guigeCount == 0) {
        if (parseInt(quantity) <= 0) {
          return this.$toast({
            message: "该商品库存为0",
            duration: 2000,
          });
        }
        this.$router.push({
          path: "/placeorder",
          query: {
            inventory_nbr: this.assessmentDetail.nbr,
            quantity: this.num,
            supNbr: this.userInfo.nbr,
            postageBuy: this.postageBuy ? '1' : '0',
          },
        });
      } else {
        this.$toast({
          message: "请选择规格",
          duration: 2000,
        });
      }
    },
    collected() {
      let userNbr = "";
      if (this.userInfo) {
        userNbr = this.userInfo.nbr;
      }
      let goodNbr = this.goodNbr;
      let isCollected = this.isCollected;
      let obj = {};
      let collectionState = 0;
      if (isCollected == 0) {
        collectionState = 1;
        obj = {
          jydm: "flow_10012",
          flow_10012: {
            user_nbr: userNbr,
            commodity_nbr: goodNbr,
          },
        };
      } else {
        collectionState = 0;
        obj = {
          jydm: "flow_10013",
          flow_10013: {
            user_nbr: userNbr,
            commodity: [{ nbr: goodNbr }],
          },
        };
      }
      this.$commonPost(obj)
        .then((response) => {
          this.isCollected = collectionState;
          this.getCommodityCollection();
          this.$toast({
            message: response.resp_msg,
            duration: 2000,
          });
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    specificationBtn: function (key, value, num) {
      let text = "";
      let selectArr = this.selectArr;
      if (num == 0) {
        return this.$toast({
          message: "该规格库存为0",
          duration: 2000,
        });
      }
      selectArr.map((item, index) => {
        if (item.key == key) {
          if (item.value == value) {
            selectArr[index].value = "";
          } else {
            selectArr[index].value = value;
          }
        }
      });
      let dIndex = 0;
      for (let i = 0; i < selectArr.length; i++) {
        if (selectArr[i].value != "") {
          if (i == dIndex) {
            text = selectArr[i].value;
          } else {
            text += "," + selectArr[i].value;
          }
        } else {
          dIndex += 1;
        }
      }
      let assessmentDetail = this.assessmentDetail;
      let goods_detail = this.goods_detail;
      let propertyListJson = this.propertyListJson;
      let checkPriceChange = this.checkPriceChange;
      let count = 0;
      selectArr.map((item) => {
        if (item.value == "" || !item.value) {
          count += 1;
        }
      });
      this.thisCheckNoClick(selectArr);
      this.guigeCount = count;
      this.guige = text;
      this.selectArr = selectArr;
      let inventoryList = [];
      if (count == selectArr.length) {
        assessmentDetail.minimumSellNum = 1;
        assessmentDetail.addStep = 1;
        assessmentDetail.inventoryLogo = goods_detail.commodityLogo;
        assessmentDetail.directorPrice = checkPriceChange(
          goods_detail.minDirectorPrice,
          goods_detail.maxDirectorPrice
        );
        assessmentDetail.agentPrice = checkPriceChange(
          goods_detail.minAgentPrice,
          goods_detail.maxAgentPrice
        );
        assessmentDetail.sellPrice = checkPriceChange(
          goods_detail.minSellPrice,
          goods_detail.maxSellPrice
        );
        assessmentDetail.quantity = this.quantity;
        this.assessmentDetail = assessmentDetail;
        this.num = assessmentDetail.minimumSellNum;
        this.checkNum();
      } else if (count > 0) {
        let propertyList = this.goods_detail.commodityInventoryList;
        let propertyArr = [];
        for (let a = 0; a < selectArr.length; a++) {
          if (selectArr[a].value) {
            let aItem = {
              propertyName: selectArr[a].key,
              propertyValue: selectArr[a].value,
            };
            propertyArr.push(aItem);
          }
        }
        for (let b = 0; b < propertyList.length; b++) {
          let bItem = propertyList[b].propertyListJson;
          let count = 0;
          for (let c = 0; c < propertyArr.length; c++) {
            if (
              JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) !=
              -1
            ) {
              count += 1;
            }
          }
          if (count == propertyArr.length) {
            inventoryList.push(propertyList[b]);
          }
        }
        this.assessmentDetail = JSON.parse(JSON.stringify(inventoryList[0]));
        this.num = this.assessmentDetail.minimumSellNum;
        this.checkNum();
      } else {
        this.checkItem(selectArr);
      }
    },
    checkPriceChange(a, b) {
      if (a == b) {
        return a;
      } else {
        return a + "-" + b;
      }
    },
    thisCheckNoClick(selectArr) {
      let quantityArr = this.quantityArr;
      let propertyListJson = this.propertyListJson;
      propertyListJson.map((json, index1) => {
        json.children.map((child, index2) => {
          let arr = [];
          arr.length = propertyListJson.length;
          arr[index1] = {
            propertyName: json.name,
            propertyValue: child.name,
          };
          selectArr.map((select, index3) => {
            if (index3 != index1) {
              arr[index3] = {
                propertyName: select.key,
                propertyValue: select.value,
              };
            }
          });
          if (JSON.stringify(quantityArr).indexOf(JSON.stringify(arr)) > 0) {
            child.quantity = 0;
          } else {
            child.quantity = 1;
          }
        });
      });
      this.propertyListJson = propertyListJson;
    },
    checkItem: function (selectArr) {
      let propertyArr = [];
      let propertyList = this.goods_detail.commodityInventoryList;
      for (let a = 0; a < selectArr.length; a++) {
        let aItem = {
          propertyName: selectArr[a].key,
          propertyValue: selectArr[a].value,
        };
        propertyArr.push(aItem);
      }
      for (let b = 0; b < propertyList.length; b++) {
        let bItem = propertyList[b].propertyListJson;
        let count = 0;
        for (let c = 0; c < propertyArr.length; c++) {
          if (
            JSON.stringify(bItem).indexOf(JSON.stringify(propertyArr[c])) != -1
          ) {
            count += 1;
          }
        }
        if (count == bItem.length) {
          this.assessmentDetail = JSON.parse(JSON.stringify(propertyList[b]));
          this.num = this.assessmentDetail.minimumSellNum;
        }
      }
      if (this.guigeCount == 0) {
        this.checkNum();
      }
      this.$forceUpdate(); //重绘
    },
    checkNoClick: function () {
      let propertyList = this.goods_detail.commodityInventoryList;
      let quantityArr = [];
      for (let i = 0; i < propertyList.length; i++) {
        if (propertyList[i].quantity == 0) {
          let propertyComplete = propertyList[i].propertyListJson;
          quantityArr.push(propertyComplete);
        }
      }
      this.quantityArr = quantityArr;
    },
    isMay: function (result) {
      for (let i = 0; i < result.length; i++) {
        if (result[i] == "") {
          return true; //如果数组里有为空的值，那直接返回true
        }
      }
      if (this.shopItemInfo[result].num == undefined) {
        return false;
      }
      return this.shopItemInfo[result].num == 0 ? false : true; //匹配选中的数据的库存，若不为空返回true反之返回false
    },
    tocart() {
      this.$router.push({
        path: "/cart",
        query: { supNbr: this.userInfo.nbr },
      });
    },
    gocart() {
      let userNbr = "";
      if (this.userInfo) {
        userNbr = this.userInfo.nbr;
      }
      let quantity = this.assessmentDetail.quantity || 0;
      if (this.guigeCount == 0) {
        if (parseInt(quantity) <= 0) {
          return this.$toast({
            message: "该商品库存为0",
            duration: 2000,
          });
        }
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_30001",
            user_nbr: userNbr,
            commodity_nbr: this.goodNbr,
            inventory_nbr: this.assessmentDetail.nbr,
            quantity: this.num,
          },
        })
          .then((response) => {
            this.show = false;
            this.$toast({
              message: "已加入购物车！",
              duration: 2000,
            });
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      } else {
        this.$toast({
          message: "请选择规格",
          duration: 2000,
        });
      }
    },
    upguige() {
      this.playerShow = false;
      this.playing = false;
      this.show = true;
      // if (this.assessmentDetail.quantity > 0) {
      //   this.show = true;
      // } else {
      //   this.$toast({
      //     message: "该商品库存为0",
      //     duration: 2000
      //   });
      // }
    },
    drawVerticalWords(ctx, str, x, y, h) {
      let arr = str.split("");
      for (let i = 0; i < arr.length; i++) {
        ctx.fillText(arr[i], x, y + h * i);
      }
    },
    //圆角矩形
    drawRoundRect(ctx, r, x, y, w, h, img) {
      ctx.save();
      if (w < 2 * r) r = w / 2;
      if (h < 2 * r) r = h / 2;
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.stroke();
      ctx.closePath();
      ctx.clip();
      this.drawImageCover(ctx, img, x, y, w, h);
      ctx.restore(); // 返回上一状态
    },
    cavansImage1(index) {
      let that = this;
      if (!that.shareSwitch1) return false;
      that.shareSwitch1 = false;
      let toast = that.$toast.loading({
        mask: false,
        message: "图片生成中...",
        duration: 0,
      });
      let canvas = document.createElement("canvas");
      let imgLoading = false;
      let item = that.materialList[index];
      let imgArr = item.imgArr;
      if (imgArr.length < 4 && imgArr.length >= 0) {
        let img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = function () {
          // 画商品图
          canvas.width = 458;
          canvas.height = 824;
          let ctx = canvas.getContext("2d");
          ctx.fillStyle = "#ffffff";
          ctx.rect(0, 0, 458, 824);
          ctx.fillRect(0, 0, 458, 824);
          ctx.fillStyle = "#222222";
          ctx.fillRect(0, 0, 458, 108);
          ctx.restore();
          that.drawImageCover(ctx, img, 22, 226, 424, 424);
          that.canvasText(ctx, canvas, toast, item, index);
        };
        img.src = imgArr[0] || item.comment_video_cover;
      } else if (imgArr.length >= 4) {
        let img1 = new Image();
        img1.crossOrigin = "Anonymous";
        img1.onload = function () {
          // 画商品图
          canvas.width = 458;
          canvas.height = 824;
          let ctx = canvas.getContext("2d");
          ctx.fillStyle = "#ffffff";
          ctx.rect(0, 0, 458, 824);
          ctx.fillRect(0, 0, 458, 824);
          ctx.fillStyle = "#222222";
          ctx.fillRect(0, 0, 458, 108);
          ctx.restore();
          that.drawImageCover(ctx, img1, 22, 226, 200, 200);
          let img2 = new Image();
          img2.crossOrigin = "Anonymous";
          img2.onload = function () {
            // 画商品图
            that.drawImageCover(ctx, img2, 236, 226, 200, 200);
            let img3 = new Image();
            img3.crossOrigin = "Anonymous";
            img3.onload = function () {
              // 画商品图
              that.drawImageCover(ctx, img3, 22, 440, 200, 200);
              let img4 = new Image();
              img4.crossOrigin = "Anonymous";
              img4.onload = function () {
                // 画商品图
                that.drawImageCover(ctx, img4, 236, 440, 200, 200);
                that.canvasText(ctx, canvas, toast, item, index);
              };
              img4.src = imgArr[3];
            };
            img3.src = imgArr[2];
          };
          img2.src = imgArr[1];
        };
        img1.src = imgArr[0];
      }
      // that.$toast({
      //     message: '生成图片失败，请重试',
      //     duration: 2000
      // });
    },
    drawImageCover(ctx, img, x, y, w, h) {
      if (img.height > img.width) {
        ctx.drawImage(
          img,
          0,
          (img.height - img.width) / 2,
          img.width,
          img.width,
          x,
          y,
          w,
          h
        );
      } else {
        ctx.drawImage(
          img,
          (img.width - img.height) / 2,
          0,
          img.height,
          img.height,
          x,
          y,
          w,
          h
        );
      }
      ctx.restore();
    },
    drawText1(ctx, text, x, y, w, l, afterText) {
      var chr = text.replace("/n", "").split("");
      var temp = "";
      var row = [];
      for (var a = 0; a < chr.length; a++) {
        if (
          ctx.measureText(temp).width < w &&
          ctx.measureText(temp + chr[a]).width <= w
        ) {
          temp += chr[a];
        } else {
          row.push(temp);
          temp = chr[a];
        }
      }
      row.push(temp);
      // for(var b = 0; b < row.length; b++){
      //     ctx.fillText(row[b],x,y+(b+1)*34);//字体20，间隔24。类似行高
      // }
      // 只显示2行，加...
      for (var b = 0; b < row.length; b++) {
        var str = row[b];
        if (b == l - 1 && row.length > l) {
          str = str.substring(0, str.length - 1) + afterText;
        }
        if (b < l) {
          ctx.fillText(str, x, y + b * 28);
        }
      }
    },
    canvasText(ctx, canvas, toast, item, index) {
      let that = this;
      let avatar = new Image();
      avatar.crossOrigin = "Anonymous";
      avatar.onload = function () {
        //  画头像
        ctx.save();
        ctx.beginPath();
        ctx.arc(54, 54, 34, 0, 2 * Math.PI);
        ctx.fill();
        ctx.clip();
        ctx.drawImage(avatar, 20, 20, 68, 68);
        ctx.restore();
        ctx.fillStyle = "#333333";
        ctx.fillText(that.user.grade, 109, 65);
        ctx.restore();
        //  画字
        ctx.save();
        ctx.font = "24px PingFang SC";
        ctx.fillStyle = "#ffffff";
        ctx.fillText(that.user.nick_name + "的店铺", 102, 63);
        ctx.save();
        ctx.fillStyle = "#333333";
        ctx.font = "20px PingFang SC";
        ctx.fillText("长按识别二维码", 292, 798);
        ctx.save();
        ctx.font = "20px bold PingFang SC";
        ctx.fillStyle = "#333";
        that.drawText1(ctx, "“" + item.content + "”", 12, 142, 424, 3, "...”");
        ctx.save();
        ctx.fillStyle = "#333333";
        ctx.font = "20px PingFang SC";
        that.drawText1(ctx, item.commodity_name, 22, 700, 270, 2, "...");
        ctx.save();
        ctx.fillStyle = "#E52B25";
        ctx.font = "24px bold PingFang SC";
        ctx.fillText("￥", 22, 798);
        ctx.save();
        ctx.font = "44px bold PingFang SC";
        ctx.fillText(item.min_sell_price, 45, 798);
        ctx.stroke();
        // 画二维码
        let code = new Image();
        code.crossOrigin = "Anonymous";
        code.onload = function () {
          ctx.save();
          ctx.drawImage(code, 315, 670, 100, 100);
          ctx.restore();
          ctx.scale(2, 2);
          that.shareImage = canvas.toDataURL("image/jpg");
          that.materialList[index].shareImage = that.shareImage;
          toast.clear();
          that.shareScore();
          that.shareSwitch1 = true;
        };
        code.src = that.materialList[index].qrCode;
      };
      avatar.src = that.user.head_pic;
    },
    // 下载提示
    downloadImg() {
      this.$toast({
        message: "请长按保存图片",
        duration: 2000,
      });
    },
    // 分享朋友
    wechatShareBtn1() {
      this.$toast({
        message: "请点击右上角进行分享",
        duration: 2000,
      });
    },
    // 分享朋友圈
    wechatShareBtn2() {
      this.$toast({
        message: "请点击右上角进行分享",
        duration: 2000,
      });
    },
    drawText(ctx, text, x, y, w) {
      var chr = text.split("");
      var temp = "";
      var row = [];
      for (var a = 0; a < chr.length; a++) {
        if (
          ctx.measureText(temp).width < w &&
          ctx.measureText(temp + chr[a]).width <= w
        ) {
          temp += chr[a];
        } else {
          row.push(temp);
          temp = chr[a];
        }
      }
      row.push(temp);
      // for(var b = 0; b < row.length; b++){
      //     ctx.fillText(row[b],x,y+(b+1)*34);//字体20，间隔24。类似行高
      // }
      // 只显示2行，加...
      for (var b = 0; b < row.length; b++) {
        var str = row[b];
        if (b == 1 && row.length > 2) {
          str = str.substring(0, str.length - 1) + "...";
        }
        if (b < 2) {
          ctx.fillText(str, x, y + (b + 1) * 34);
        }
      }
    },
    initPage() {
      this.checkOption();
      this.getInfoByUser();
    },
    checkOption() {
      let that = this;
      that.is_support_presale_chat = localStorage.getItem("otherConfig_10007");
      if (!(this.userInfo && this.userInfo.nbr)) {
        this.isLogin = 0;
      } else {
        this.isLogin = 1;
      }
    },
    goqrcode1(index) {
      let option = {
        title: this.materialList[index].commodity_name,
        desc: this.materialList[index].content || "",
        link: `${location.origin}/materialDetail?nbr=${this.materialList[index].share_nbr}&supNbr=${this.userInfo.nbr}`,
        images:
          this.materialList[index].imgArr[0] ||
          this.materialList[index].comment_video_cover,
      };
      this.weChatShare(option);
      this.shareImage = "";
      if (this.materialList[index].shareImage) {
        this.shareImage = this.materialList[index].shareImage;
        this.showshare1 = true;
        return false;
      }
      this.createCommodityCode1(index);
    },
    goqrcode() {
      let that = this
      this.playerShow = false;
      this.playing = false;
      if (this.commodityShareArr.length > 0) {
        this.qrcodeshare = true;
        this.showshare = true;
        // setTimeout(()=>{
        //   let shareBox= that.$refs.shareBox
        //   shareBox.scrollLeft=shareBox.clientWidth/2-10
        // },100)
      } else {
        this.createCommodityCode();
      }
      this.shareScore()
    },
    createCommodityCode() {
      let that = this;
      let toast = that.$toast.loading({
        mask: false,
        message: "图片生成中...",
        duration: 0,
      });
      that.$post("/api/wechat/gzh/generateNewQRCode", {
        page: "/listdetail",
        supNbr: that.userInfo.nbr,
        nbr: that.goodNbr,
      })
        .then((res) => {
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              that.qrCode = resp.qrcode;
              that.createCommodityShareUrl(toast);
            } else {
              toast.clear();
              that.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          } else {
            toast.clear();
            that.$toast({
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          toast.clear();
          that.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    createCommodityShareUrl(toast) {
      let that = this;
      let commodityList = that.goods_detail;
      let endTime = ''
      if (commodityList.endTime != `2030-01-01 00:00:00`) {
        endTime = `${commodityList.endTime.substring(5, 7)}月${commodityList.endTime.substring(8, 10)}日${commodityList.endTime.substring(11, 16)}结束`
      }
      let oldPrice = commodityList.commodityInventoryList ? commodityList.commodityInventoryList[0].oldPrice : ''
      let sellPrice = commodityList[`minSellPrice`]
      that.$post("/api/image/share/generateYMCommodityShareImage", {
        username: encodeURIComponent(that.userName),
        userHeadUrl: that.userAvatar,
        commodityUrl: commodityList.commodityLogo,
        codeUrl: that.qrCode,
        commodityName: encodeURIComponent(commodityList.commodityName),
        commodityDesc: encodeURIComponent(commodityList.commoditySummary || ''),
        oldPrice: oldPrice,
        sellPrice: sellPrice,
        endTime: endTime,
      })
        .then((res) => {
          toast.clear();
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              that.commodityShareArr = [resp.imageUrl]//resp.imageUrl2,
              that.qrcodeshare = true;
              that.showshare = true;
              // setTimeout(()=>{
              //   let shareBox= that.$refs.shareBox
              //   shareBox.scrollLeft=shareBox.clientWidth/2-10
              // },150)
            } else {
              that.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          } else {
            that.$toast({
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          toast.clear();
          that.$toast({
            message: "分享图合成失败，请重试",
            duration: 2000,
          });
        });
    },
    shareScore() {
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_150008",
          user_nbr: this.userInfo.nbr,
        },
      });
    },
    createCommodityCode1(index) {
      let that = this;
      let toast = that.$toast.loading({
        mask: false,
        message: "获取二维码",
        duration: 0,
      });
      that.$post("/api/wechat/gzh/generateNewQRCode", {
        page: "/materialDetail",
        supNbr: that.userInfo.nbr,
        nbr: that.materialList[index].share_nbr,
      })
        .then((res) => {
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              toast.clear();
              that.materialList[index].qrCode = resp.qrcode;
              that.cavansImage1(index);
              that.showshare1 = true;
            }
          }
        })
        .catch((err) => {
          that.$toast({
            message: "二维码获取失败，请重试",
            duration: 2000,
          });
        });
    },
    colseshare1() {
      this.$toast.clear();
      this.showshare1 = false;
      let data = this.goods_detail;
      let option = {
        title: data.shareTitle || data.commodityName,
        desc: data.commoditySummary || "",
        link: `${location.origin}/listdetail?nbr=${this.goodNbr}&supNbr=${this.userInfo.nbr}`,
        images: data.shareImage || this.images[0],
      };
      this.weChatShare(option);
    },
    colseshare() {
      this.$toast.clear();
      this.qrcodeshare = false;
      this.showshare = false;
    },
    timer() {
      let date = new Date();
      let toTime = this.goods_detail.endTime.replace(/\-/g, "/");
      let thisTime = `${date.getFullYear()}/${date.getMonth() + 1
        }/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTamp = parseInt(new Date(toTime) - new Date(thisTime)) / 1000;
      let timeText = ``;
      if (timeTamp <= 0) {
        timeText = `00:00:00:00`;
      } else {
        timeText = `${this.addZero(
          parseInt(timeTamp / (60 * 60 * 24))
        )}:${this.addZero(
          parseInt((timeTamp % (60 * 60 * 24)) / (60 * 60))
        )}:${this.addZero(
          parseInt((timeTamp % (60 * 60)) / 60)
        )}:${this.addZero(parseInt(timeTamp % 60))}`;
      }
      this.countdown = timeText;
    },
    timers() {
      let date = new Date();
      let toTime = this.goods_detail.startTime.replace(/\-/g, "/");
      let thisTime = `${date.getFullYear()}/${date.getMonth() + 1
        }/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTamp = parseInt(new Date(toTime) - new Date(thisTime)) / 1000;
      let timeText = ``;
      if (timeTamp <= 0) {
        timeText = `00:00:00`;
      } else {
        timeText = `${this.addZero(
          parseInt(timeTamp / (60 * 60))
        )}:${this.addZero(parseInt((timeTamp / 60) % 60))}:${this.addZero(
          parseInt(timeTamp % 60)
        )}`;
      }
      this.countdowns = timeText;
    },
    addZero(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
    checkName(name) {
      let result = "";
      let nameArr = name.split("");
      let length = name.replace(/[\u0391-\uFFE5]/g, "aa").length;
      if (length >= 4) {
        result = nameArr[0] + "**" + nameArr[nameArr.length - 1];
      } else {
        result = name;
      }
      return result;
    },
    spliceContent(name) {
      let result = "";
      let regxp = /([\u4E00-\u9FA5]|[\uFE30-\uFFA0])/;
      let nameArr = name.split("");
      let realLength = name.replace(regxp, "aa").length;
      let length = 0;
      if (realLength > 120) {
        nameArr.map((text, index) => {
          if (length < 120) {
            if (regxp.test(text)) {
              result += text;
              length += 2;
            } else {
              result += text;
              length += 1;
            }
          }
        });
        result += "...";
      } else {
        result = name;
      }
      return result;
    },
    getMaterial() {
      this.$commonPost({
        jydm: "flow_70103",
        flow_70103: {
          commodity_nbr: this.goodNbr || "",
          page_index: 0,
          num_per_page: 3,
        },
      })
        .then((response) => {
          let arr = [];
          if (response.list) {
            if (response.list.length > 1) {
              arr = response.list;
            } else {
              arr.push(response.list);
            }
          }
          arr.map((item) => {
            if (item.comment_image) {
              item.imgArr = item.comment_image.split(",");
            } else {
              item.imgArr = [];
            }
            if (item.share_nick_name) {
              item.mainName = this.checkName(item.share_nick_name);
            }
            item.mainContent = this.spliceContent(item.content);
          });
          this.materialTotal = response.total_rows;
          this.materialList = arr;
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    getCommodityCollection() {
      this.$commonPost({
        jydm: "flow_70059",
        flow_70059: {
          nbr: this.goodNbr,
          user_nbr: this.userInfo.nbr || '',
          wechat_version: 1,
        },
      })
        .then((response) => {
          this.collectionNum = response.commodity.collection_num;
          this.coupon_name = response.commodity.coupon_name || "";
          this.quantity = response.commodity.quantity;
          this.postage_pay = response.commodity.safe_amount || ''
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    getInfoByUser() {
      if (this.userInfo && this.userInfo.nbr) {
        let userNbr = this.userInfo.nbr;
        // 用户的基本信息(身份)
        this.$commonPost({
          jydm: "flow_10003",
          flow_10003: {
            user_nbr: userNbr,
          },
        })
          .then((response) => {
            response.grade =
              response.role == "0"
                ? "粉丝"
                : response.role == "1"
                  ? this.agentText
                  : response.role == "2"
                    ? this.directorText
                    : "总监";
            response.role == "0"
              ? "sell"
              : response.role == "1"
                ? "sell"
                : response.role == "2"
                  ? "agent"
                  : "director";
            if (response.role == 0 || response.role == 1) {
              this.roleText = "Sell";
            } else if (response.role == 2) {
              this.roleText = "Agent";
            } else if (response.role == 3) {
              this.roleText = "Director";
            }
            this.user = response;
            this.userName = response.nick_name;
            this.userAvatar = response.head_pic;
            let data = this.goods_detail;
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });

        // 用户的收藏状态
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_10015",
            user_nbr: userNbr,
            commodity_nbr: this.goodNbr,
          },
        })
          .then((response) => {
            this.isCollected = response.collection_state;
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
        this.$commonPost({
          jydm: "flow_10057",
          flow_10057: {
            user_nbr: this.userInfo.nbr,
            commodity_nbr: this.goodNbr,
          },
        })
          .then((response) => {
            this.warn = response.warn;
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      }
    },
    getSiyuDetail() {
      let that = this
      this.$post("/api/customer/siyunote/queryNoteDetail", {
        noteId: this.goods_detail.noteId,
      })
        .then((res) => {
          if (res.code == "200") {
            let resp = res.object.resp;
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              let contentList = resp.note ? resp.note.contentList || [] : []
              contentList.forEach((item) => {
                if (item.type == '3') {
                  item.options = {
                    autoplay: false,
                    muted: false,
                    loop: false,
                    preload: "auto",
                    language: "zh-CN",
                    aspectRatio: "4:3",
                    fluid: true,
                    poster: "",
                    notSupportedMessage: "此视频暂无法播放，请稍后再试",
                    controlBar: {
                      remainingTimeDisplay: false,
                      fullscreenToggle: true,
                    },
                    sources: [
                      {
                        src: item.content
                      }
                    ]
                  }
                }
              })
              that.siyuInfo = contentList
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          } else {
            this.$toast({
              message: resp.message,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
  },
  created() { },
  activated() { },
  mounted() {
    window.scrollTo(0, 0);
    let that = this;
    this.qrcodeshare = false;
    this.showshare = false;
    document.title = "商品详情";
    let userNbr = "";
    if (this.userInfo) {
      userNbr = this.userInfo.nbr;
    }
    this.goodNbr = this.$route.query.nbr;

    // 商品一般信息
    let toast = this.$toast.loading({
      mask: false,
      duration: 0,
    });
    this.checkOption();
    this.activeTab = '0'
    this.siyuInfo = []
    this.$post("/api/customer/queryCommodityDetail", {
      commodityNbr: this.goodNbr,
    })
      .then((res) => {
        if (res.code != 200) return this.$toast({
          message: res.data.message,
          duration: 2000,
        });
        let arr = [];
        let data = res.object.resp.commodity;
        let text = "";
        let propertyArr = [];
        if (res.code == "200") {
          let resp = res.object.resp;
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            if (data.commodityLogoList) {
              arr = data.commodityLogoList.split(",");
            }
            data.endTime = data.endTime.slice(0, 19);
            data.commodityDesc = handleText(data.commodityDesc);

            let videoItem = [], videoImgList = []
            if (data.descVideo) {
              videoItem = data.descVideo.split(',')
            }
            if (data.descVideoCover) {
              videoImgList = data.descVideoCover.split(',')
            }
            let videoList = []
            if (videoItem.length > 0 && videoImgList.length > 0) {
              videoItem.forEach((item, index) => {
                let obj = {
                  url: item,
                  cover: videoImgList[index] || videoImgList[0],
                  loadVideo: false,
                }
                videoList.push(obj)
              })
            }

            if (data.licensePic) {
              this.licensePicArr = data.licensePic.split(',')
            }

            this.goods_detail = data;
            this.siyuInfo = {}
            if (data.noteId) this.getSiyuDetail();

            this.videoList = videoList;
            this.timers();
            this.timer1 = setInterval(() => {
              this.timers();
            }, 1000);
            this.images = arr;
            this.propertyListJson = data.propertyJson;
            this.salesNum = data.salesNum;
            // let setTimer = setInterval(()=>{
            //    let speed = widthNum / 50;
            //    this.widthNum += speed;
            //    if(this.widthNum >= widthNum){
            //      clearInterval(setTimer);
            //    }
            // },20);
            let commodityInventoryList = data.commodityInventoryList;
            // let iCount = 0;
            // for (var i in commodityInventoryList) {
            //   if(commodityInventoryList[i].quantity != 0){
            //     commodityInventoryList[i].propertyListJson.map((item,j)=>{
            //       if (j == 0) {
            //         text = item.propertyValue;
            //        } else {
            //         text += "," + item.propertyValue;
            //        }
            //        let obj = {
            //           key: item.propertyName,
            //           value: item.propertyValue
            //        };
            //        propertyArr.push(obj);
            //     })
            //     break;
            //   }else{
            //     iCount += 1;
            //   }
            // }
            // if(iCount == commodityInventoryList.length){
            //   commodityInventoryList[0].propertyListJson.map((item,j)=>{
            //     if (j == 0) {
            //       text = item.propertyValue;
            //     } else {
            //       text += "," + item.propertyValue;
            //     }
            //     let obj = {
            //       key: item.propertyName,
            //       value: item.propertyValue
            //     };
            //     propertyArr.push(obj);
            //   })
            //   this.guigeCount = propertyArr.length;
            // }
            if (commodityInventoryList.length == 1 && commodityInventoryList[0].quantity > 0) {
              commodityInventoryList[0].propertyListJson.map((item, j) => {
                if (j == 0) {
                  text = item.propertyValue;
                } else {
                  text += "," + item.propertyValue;
                }
                let obj = {
                  key: item.propertyName,
                  value: item.propertyValue
                };
                propertyArr.push(obj);
              })
              this.guigeCount = 0;
            } else {
              this.guigeCount = data.propertyJson.length;
              data.propertyJson.map((item, j) => {
                let obj = {
                  key: item.name,
                  value: "",
                };
                propertyArr.push(obj);
              });
            }
            this.guige = text;
            this.selectArr = propertyArr;
            this.checkItem(propertyArr);
            this.checkNoClick();
            this.thisCheckNoClick(propertyArr);
            this.dataLoading = true;
            this.playerOptions.poster =
              this.goods_detail.commodityVideoCover || this.images[0];
            this.playerOptions.sources.push({
              src: this.goods_detail.commodityVideo,
            });
            // if(this.goods_detail.descVideoCover && this.goods_detail.descVideo){
            //   this.descPlayerOptions.poster =this.goods_detail.descVideoCover;
            //   this.descPlayerOptions.sources.push({
            //     src: this.goods_detail.descVideo,
            //   });
            // }
            toast.clear();
            let userNbr = "";
            if (that.userInfo) {
              userNbr = that.userInfo.nbr;
            }
            let option = {
              title: data.shareTitle || data.commodityName,
              desc: data.commoditySummary || "",
              link: `${location.origin}/listdetail?nbr=${that.goodNbr}&supNbr=${userNbr}`,
              images: data.shareImage || arr[0],
            };
            that.weChatShare(option);
            setTimeout(() => {
              new Swiper(".swiper-container", {
                autoplay: false,
                autoHeight: true,
                speed: 400,
                onSlideChangeEnd(swiper) {
                  if (
                    that.$refs.videoPlayer &&
                    swiper.activeIndex != that.oldCurrent
                  ) {
                    that.oldCurrent = swiper.activeIndex;
                    that.$refs.videoPlayer.player.pause();
                    that.$refs.videoPlayer.$refs.video.pause();
                  }
                },
                onSlideChangeStart(swiper) {
                  that.current = swiper.activeIndex;
                },
              });
            }, 200);
            if (data.endTime == `2030-01-01 00:00:00`) return false;
            this.timer();
            this.timer2 = setInterval(() => {
              this.timer();
            }, 1000);
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000,
            });
          }
        } else {
          this.$toast({
            message: resp.message,
            duration: 2000,
          });
        }
      })
      .catch((err) => {
        this.$toast({
          message: err.message,
          duration: 2000,
        });
      });

    // 店铺信息
    this.$commonPost({
      jydm: "flow_70218",
      flow_70218: {
        nbr: this.goodNbr,
      },
    })
      .then((response) => {
        this.storeInfo = response.nbr ? response : {};
      })
      .catch((err) => {
        this.$toast({
          message: err.message,
          duration: 2000,
        });
      });
    // 2条评价
    // this.$commonPost({
    //   jydm: "flow_70072",
    //   flow_70072: {
    //     nbr: this.goodNbr,
    //     page_index: "0",
    //     num_per_page: "2",
    //   },
    // })
    //   .then((response) => {
    //     let arr = [];
    //     if (response.total_rows > 0) {
    //       if (response.comment.length > 0) {
    //         arr = response.comment;
    //       } else {
    //         arr.push(response.comment);
    //       }
    //       arr.map((item) => {
    //         if (item.comment_image) {
    //           item.images = item.comment_image.split(",");
    //         }
    //       });
    //     }
    //     this.evaluate = arr;
    //     this.totalRows = response.total_rows;
    //   })
    //   .catch((err) => {
    //     this.$toast({
    //       message: err.message,
    //       duration: 2000,
    //     });
    //   });

    // 商品优惠券
    this.$commonPost({
      jydm: "flow_70208",
      flow_70208: {
        user_nbr: this.userInfo.nbr,
        commodity_nbr: this.goodNbr,
      },
    })
      .then((response) => {
        let arr = [];
        if (response.list) {
          if (response.list.length > 0) {
            arr = response.list;
          } else {
            arr.push(response.list);
          }
        }
        this.couponList = arr;
      })
      .catch((err) => {
        this.$toast({
          message: err.message,
          duration: 2000,
        });
      });
    // 素材
    this.getMaterial();
    //商品的收藏和库存
    this.getCommodityCollection();
    this.getInfoByUser();
  },
  destroyed() {
    this.timer1 && clearInterval(this.timer1);
    this.timer2 && clearInterval(this.timer2);
  },
};
</script>
<style scoped lang='stylus'>
  .detailHtml>>>img {
    width: 100%;
    height: auto;
  }

  .wrapper>>>.van-overlay {
    background-color: rgba(51, 51, 51, 0.5) !important;
  }

  .box>>>.van-overlay {
    z-index: 50 !important;
  }
</style>
<style scoped src="./listdetail.css" lang="less"></style>
<style lang="stylus" scoped>
  .detail-top>>>.video-js .vjs-big-play-button {
    border-radius: 50%;
    width: 1.2rem !important;
    height: 1.2rem !important;
    line-height: 1.2rem !important;
    margin-left: -0.6rem !important;
  }

  .detail-top>>>.swiper-slide .img {
    width: 100% !important;
    height: 7.5rem !important;
    object-fit: cover;
  }

  .guige-popup>>>.van-popup {
    /* height: 9.48rem; */
    max-height: auto;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    overflow: hidden;
  }

  .detail-top>>>.swiper-slide .player {
    width: 1rem;
    height: 1rem;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0.3rem;
    left: 0.3rem;
    border-radius: 50%;
  }

  .detail-top>>>.swiper-slide .player img {
    width: 0.4rem;
    height: 0.4rem;
    margin-left: 0.1rem;
  }

  .descVideoWrap>>>.video-js .vjs-big-play-button {
    border-radius: 50%;
    width: 1rem !important;
    height: 1rem !important;
    line-height: 1rem !important;
    margin-left: -0.5rem !important;
  }

  .descVideoBox>>>.video-js {
    padding-top: 50.99%
  }

  .descVideoBox>>>.vjs-tech {
    width: 7.02rem;
    height: 3.58rem;
  }

  .siyuBoxItem>>>.video-js .vjs-big-play-button {
    border-radius: 50%;
    width: 1rem !important;
    height: 1rem !important;
    line-height: 1rem !important;
    margin-left: -0.5rem !important;
  }

  .siyuBoxItem>>>.video-js {
    padding-top: 50.99%
  }

  .siyuBoxItem>>>.vjs-tech {
    width: 7.1rem;
    height: 3.62rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/listdetail.vue